import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '@seu-services';
import { SeuConfigTranslationObject } from '@seu-types';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigSynonyms',
  standalone: true,
})
export class SeuConfigSynonymsPipe implements PipeTransform {
  constructor(private store: StoreService) {}

  public transform(value: string): string[] {
    const lang = 'de';

    const keyArray = value.split('.');
    let returnValue: string | string[] | null = keyArray[keyArray.length - 1];
    let translationObject = this.store.getConfig()?.translations[lang];

    keyArray.forEach((key: string) => {
      if (translationObject) {
        const translationValue = translationObject[key];
        if (translationValue) {
          if (typeof translationValue === 'object') {
            if (Array.isArray(translationValue)) {
              returnValue = translationValue as string[];
            } else {
              translationObject =
                translationValue as SeuConfigTranslationObject;
            }
          }
        } else if (translationValue === '') {
          returnValue = '';
        }
      }
    });

    if (Array.isArray(returnValue)) {
      return returnValue;
    }

    return [returnValue as string];
  }
}
